module.exports = __webpack_public_path__ + "img/cepsa-login.ea77d9a0.png";